gfHandler = {

    init = function(){
        var self = this;

        $(document).on('gform_post_render', function (event, form_id, current_page) {
            //$.fn.fullpage.reBuild();
        });
    }
}